// extracted by mini-css-extract-plugin
export default {"UserFilter":"SearchUserItem_UserFilter__Sgpu3"};